import { Controller } from '@hotwired/stimulus'

// Reading font-size cycle. The Aa button steps the prose container through a
// fixed set of size classes (small → base → large → x-large → small …). The
// chosen step is persisted to localStorage and restored on connect, so a
// reader's preferred size sticks across chapters and reloads. Auto-registered
// by the controllers glob. The controller lives on the reader wrapper and
// targets the prose container (falling back to its own element if absent).
const STEPS = ['font-read-sm', 'font-read-base', 'font-read-lg', 'font-read-xl']
const STORAGE_KEY = 'reader-font-step'
const DEFAULT_INDEX = 1

export default class extends Controller {
  static targets = ['prose']

  connect() {
    this.index = this.restore()
    this.apply()
  }

  cycle() {
    this.index = (this.index + 1) % STEPS.length
    this.persist()
    this.apply()
  }

  apply() {
    const el = this.proseElement
    STEPS.forEach((cls) => el.classList.remove(cls))
    el.classList.add(STEPS[this.index])
  }

  get proseElement() {
    return this.hasProseTarget ? this.proseTarget : this.element
  }

  restore() {
    try {
      const saved = parseInt(localStorage.getItem(STORAGE_KEY), 10)
      if (!Number.isNaN(saved) && saved >= 0 && saved < STEPS.length) return saved
    } catch (e) {
      // localStorage unavailable (private mode) — fall back to the default.
    }
    return DEFAULT_INDEX
  }

  persist() {
    try {
      localStorage.setItem(STORAGE_KEY, String(this.index))
    } catch (e) {
      // Ignore — the class is still applied for this session.
    }
  }
}
